import { IconOnlyButtonProps } from "./types";

const IconOnlyButton = ({ icon }: IconOnlyButtonProps) => {
    return icon;
};

export default IconOnlyButton;
